import { render, staticRenderFns } from "./GalleryUpload.vue?vue&type=template&id=172e2b7a"
import script from "./GalleryUpload.vue?vue&type=script&lang=js"
export * from "./GalleryUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports